<script lang="ts">
  import { bodyHtml, loadExternalImage } from '../logic/markdown';
  import { watchTableFrames } from '../logic/tableScroll';
  import { drawMermaid, MERMAID_BLOCKS } from '../logic/mermaid';
  interface Props {
    html?: string | null;
    md?: string | null;
    class?: string;
  }
  let { html = null, md = null, class: cls = 'comment-body' }: Props = $props();
  const rendered = $derived(bodyHtml(html, md));
  let root: HTMLDivElement | undefined = $state();

  $effect(() => {
    void rendered;
    if (root) return watchTableFrames(root);
  });
  // Mermaid blocks as their diagrams (logic/mermaid), loading mermaid only for a body that has one.
  $effect(() => {
    void rendered;
    if (root?.querySelector(MERMAID_BLOCKS)) return drawMermaid(root);
  });
</script>

<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions (delegates to the "Load image" buttons inside) -->
<div class={cls} bind:this={root} onclick={loadExternalImage}>{@html rendered}</div>
